import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_3 = {
  class: "d-sm-flex align-items-center",
  style: {"width":"100%"}
}
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_5 = { class: "table-responsive" }
const _hoisted_6 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_7 = { class: "d-flex align-items-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = {
  class: "modal fade",
  id: "stockDetailsModal",
  tabindex: "-1",
  "aria-labelledby": "stockDetailsModalLabel",
  "aria-hidden": "true"
}
const _hoisted_10 = { class: "modal-dialog modal-lg" }
const _hoisted_11 = { class: "modal-content" }
const _hoisted_12 = { class: "modal-header" }
const _hoisted_13 = { class: "modal-title" }
const _hoisted_14 = { class: "modal-body" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { class: "table table-bordered" }
const _hoisted_17 = { class: "table table-bordered" }
const _hoisted_18 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Form = _resolveComponent("Form")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_Form, {
          style: {"width":"100%"},
          class: "search-bg svg-color pt-3"
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [
            _createElementVNode("div", { class: "row" }, null, -1)
          ])),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("table", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "Nom produit"),
              _createElementVNode("th", null, "Quantité")
            ])
          ], -1)),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: produit.id || index
              }, [
                _createElementVNode("td", null, _toDisplayString(produit.nomProd), 1),
                _createElementVNode("td", _hoisted_7, [
                  _createTextVNode(_toDisplayString(produit.qtitePhysique) + " ", 1),
                  _createElementVNode("i", {
                    class: "fa fa-solid fa-eye ms-3 cursor-pointer text-primary",
                    title: "Voir les détails",
                    onClick: ($event: any) => (_ctx.showDetails(produit)),
                    "data-bs-toggle": "modal",
                    "data-bs-target": "#stockDetailsModal"
                  }, null, 8, _hoisted_8)
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h5", _hoisted_13, _toDisplayString(_ctx.selectedProduit?.nomProd || 'Détails du produit'), 1),
              _cache[2] || (_cache[2] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, null, -1))
            ]),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.selectedProduit)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _cache[5] || (_cache[5] = _createElementVNode("h6", null, "Conditionnements", -1)),
                    _createElementVNode("table", _hoisted_16, [
                      _cache[3] || (_cache[3] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "bg-primary" }, "Code"),
                          _createElementVNode("th", { class: "bg-primary" }, "Libellé"),
                          _createElementVNode("th", { class: "bg-primary" }, "Quantité stock")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedProduit.produitconditionnements, (cond) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: cond.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(cond.conditionnement?.code), 1),
                            _createElementVNode("td", null, _toDisplayString(cond.conditionnement?.libelle), 1),
                            _createElementVNode("td", null, _toDisplayString(cond.qteStockCondLogique || 0), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _cache[6] || (_cache[6] = _createElementVNode("h6", { class: "mt-3" }, "Quantité par magasin", -1)),
                    _createElementVNode("table", _hoisted_17, [
                      _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "bg-primary" }, "Magasin"),
                          _createElementVNode("th", { class: "bg-primary" }, "Quantité"),
                          _createElementVNode("th", { class: "bg-primary" }, "Conditionnement")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.magasinStocks, (stock) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: stock.id
                          }, [
                            _createElementVNode("td", null, _toDisplayString(stock.magasin?.nomMagasin || 'Non spécifié'), 1),
                            _createElementVNode("td", null, _toDisplayString(stock.qtite), 1),
                            _createElementVNode("td", null, _toDisplayString(stock.conditionnement?.libelle || 'N/A'), 1)
                          ]))
                        }), 128))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _cache[7] || (_cache[7] = _createElementVNode("div", { class: "modal-footer" }, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary",
                "data-bs-dismiss": "modal"
              }, "Fermer")
            ], -1))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}